import script from "./PlatformChannelSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformChannelSelect.vue?vue&type=script&setup=true&lang=js"

import "./PlatformChannelSelect.vue?vue&type=style&index=0&id=6f5b9670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5b9670"]])

export default __exports__